import axios from "axios";
import $ from "jquery";
import moment from "moment";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { BiCreditCard, BiInfoCircle } from "react-icons/bi";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import CommonAsyncSelect from "../../components/CommonAsyncSelect";
import Swal from "sweetalert2";
import { ConfigContext } from "../../App";
import ApiSuccessModal from "../../components/ApiSuccessModal/ApiSuccessModal";
import Breadcrumb from "../../components/Breadcrumb";
import Header from "../../components/partials/Header";
import Sidebar from "../../components/partials/Sidebar";
import PayDtlCard from "../../components/PayDtlCard";
import TruncatedTextWithTooltip from "../../components/TruncatedTextWithTooltip";
import config, { config2 } from "../../config";
import addIcon from "../../images/icons/add.png";
import deleteIcon from "../../images/icons/delete.png";
import {
  inputAlphanumeric,
  inputfourDigitDeciaml,
  inputNumber,
  inputOnlyNumber,
  millionComma,
  playBarcodeSound,
  removeMillionComma,
  userBackDate,
} from "../../utils";
import salesSchema from "../../validations/salesSchema";
import "./style.css";
import { uomConversion, uomConversionUnit } from "./util";
import Tippy from "@tippyjs/react";
import ItemViews from "../Master/Item/view";
import CustomCurrencyInput from "../../components/CustomCurrencyInput";

function SaleEdit(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const sale = location.state?.sale;
  let filter = location.state?.currentFilter;
  let currentFilterState = location.state?.showFilter;
  let page = location.state?.currentPageNo;
  const isTemp = location.state?.is_temp || false;
  const [defaultGodown, setDefaultGodown] = useState("");
  const displayQty = useContext(ConfigContext)?.displayQty;
  const [godown, setGodown] = useState([]);
  const [showItemModal, setShowItemModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const handleItemView = (data) => {
    setSelectedItemId(data);
    setShowItemModal(true);
  };
  const handleItemModalClose = () => {
    setShowItemModal(false);
    setSelectedItemId(null);
  };

  const accessCode = useContext(ConfigContext)?.accessCode;
  const itemLevelNarration = useContext(ConfigContext)?.itemLevelNarration;
  const multiVoucher = useContext(ConfigContext)?.multiVoucher;
  const [userRole, setUserRole] = useState("");
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [validationInputs, setValidationInputs] = useState({
    user_id: "",
    access_code: "",
  });
  const [isValidated, setIsValidated] = useState(false);

  useEffect(
    function () {
      setGodown(() => props.godown);
    },
    [props],
  );

  const itemDtl = {
    item_id: "",
    item_name: "",
    requested_qty: "",
    avail_qty: "",
    billed_qty: "",
    rate: "",
    amount: "",
    disc: "",
    disc_amt: "",
    godown_id: defaultGodown,
    is_active: "",
    updatedAt: "",
    alt_conv: "",
    base_uom: "",
    alt_uom: "",
    uom: "",
    alt_qty: "",
    alt_price: "",
    alt_rate: "",
    base_rate: "",
    received_qty: "",
    updatedAt: "",
    item_min_price: "",
    alt_min_price: "",
    item_max_price: "",
    alt_max_price: "",
    narration: "",
  };

  const payDtl = [
    { mode: "Cash UGX", conv: 1, conv_amt: "", amt: "" },
    { mode: "USD", conv: 1, conv_amt: "", amt: "" },
    { mode: "Momo Pay", conv: 1, conv_amt: "", amt: "" },
    { mode: "Airtel Money", conv: 1, conv_amt: "", amt: "" },
  ];

  const initialState = {
    challan_no: "",
    challan_id: "",
    branch_id: "",
    inv_no: "",
    cust_id: "",
    challan_date: moment().format("YYYY-MM-DD"),
    payment_mode_id: 1,
    item_dtl: [itemDtl],
    narration: "",
    is_zero_value: "",
    vehicle_no: "",
    pay_dtl: payDtl,
    is_verify: "",
    voucher_id: "",
  };
  const [user, setUser] = useState("");
  const [itemList, setItemList] = useState([]);
  const [itemLoading, setItemLoading] = useState(false);

  async function getItem() {
    setItemLoading(true);
    let branch_id = user;
    if (!branch_id && localStorage.getItem("inventory")) {
      branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData
        ?.branch_data?.[0]?.branch_id;
    }

    try {
      await $.post(
        `${config.apiUrl}/item/listItem`,
        JSON.stringify({
          paginate: 0,
          is_active: 1,
          branch_id: branch_id || "",
          is_preload: 1,
        }),
        function (res) {
          setItemList(res?.data?.list || []);
        },
      );
    } catch (err) {
      console.error("Item API Error", err);
      setItemList([]);
    } finally {
      setItemLoading(false);
    }
  }

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(
        JSON.parse(localStorage.getItem("inventory"))?.userData?.branch_data[0]
          ?.branch_id,
      );
      setUserRole(
        JSON.parse(localStorage.getItem("inventory"))?.userData?.role_id,
      );
    }
  }, []);

  useEffect(() => {
    if (user) {
      getItem();
    }
  }, [user]);

  const [formInputs, setFormInputs] = useState(initialState);
  console.log("formInputsformInputs", formInputs);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedProduct, setSelectedProduct] = useState([]);

  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const [barcode, setBarcode] = useState("");
  const [barcodeLoading, setBarcodeLoading] = useState(false);
  const [highlightedRow, setHighlightedRow] = useState(null);
  const barcodeRef = useRef();

  const defaultGodownRef = useRef("");
  const godownRef = useRef([]);

  useEffect(() => {
    defaultGodownRef.current = defaultGodown;
    godownRef.current = godown;
  }, [defaultGodown, godown]);

  const discRef = useRef(0);
  const totalRef = useRef(0);

  const [totalValue, setTotalValue] = useState("");
  useEffect(() => {
    const interval = setInterval(() => {
      if (totalRef.current) {
        setTotalValue(totalRef.current.value);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);
  const focus = useRef([{}]);

  console.log(
    "totalReftotalRef",
    Number(totalRef.current.value),
    totalRef.current.value,
    discRef.current.value,
  );

  // resp modal
  const [showSccess, setShowSccess] = useState(false);
  const [resData, setResData] = useState();
  const handleSccessClose = () => setShowSccess(false);
  const handleSccessShow = () => setShowSccess(true);

  function calculateTotal() {
    discRef.current.value = 0;
    totalRef.current.value = 0;
    formInputs.item_dtl.forEach((item) => {
      totalRef.current.value = removeMillionComma(totalRef.current.value);
      let disc = isNaN(parseFloat(discRef.current.value))
        ? 0
        : parseFloat(discRef.current.value);
      let disc_amt = isNaN(parseFloat(item.disc_amt))
        ? 0
        : parseFloat(item.disc_amt);
      discRef.current.value = parseFloat(disc + disc_amt).toFixed(2);

      let total = isNaN(parseFloat(totalRef.current.value))
        ? 0
        : parseFloat(totalRef.current.value);
      let total_amt = isNaN(parseFloat(item.amount))
        ? 0
        : parseFloat(item.amount);
      let amt = parseFloat(total + total_amt).toFixed(2);
      totalRef.current.value = millionComma(amt);
    });

    setSelectedProduct((prevState) => {
      return formInputs.item_dtl;
    });
  }

  function handleInputs(e) {
    setFormInputs((prevState) => {
      let newState = {
        ...prevState,
        [e.target.name]: e.target.value,
      };
      return newState;
    });
  }
  const { globalBlocked, blockedByProduct } = useMemo(() => {
    const globalList = [];
    const prodMap = {};

    formInputs.item_dtl.forEach((row) => {
      if (!row?.godown_id) return;
      const godownId = Number(row.godown_id);

      if ([2, 4].includes(Number(row?.is_active))) {
        if (!globalList.includes(godownId)) {
          globalList.push(godownId);
        }
      }

      if (row?.item_id) {
        const itemId = Number(row.item_id);
        if (!prodMap[itemId]) prodMap[itemId] = [];
        if (!prodMap[itemId].includes(godownId)) {
          prodMap[itemId].push(godownId);
        }
      }
    });

    return { globalBlocked: globalList, blockedByProduct: prodMap };
  }, [formInputs.item_dtl]);

  function handleTableInputs(e, rowIndex) {
    let idx =
      rowIndex !== undefined
        ? rowIndex
        : window.event?.target?.closest("tr")?.getAttribute("data-id") ||
          window.event?.srcElement?.closest("tr")?.getAttribute("data-id");

    setHighlightedRow(Number(idx));

    let product = formInputs.item_dtl[idx];
    if (e.target.name == "item_id") {
      let oldProduct = product;
      product = e.target.value;
      delete product.godown_id;
      product.item_min_price = product?.item_min_price || 0;
      product.item_max_price =
        product?.item_max_price || product?.item_price || 0;
      product.alt_min_price = product?.alt_min_price || 0;
      product.alt_max_price = product?.alt_max_price || product?.alt_price || 0;
    }
    let item_max_price =
      e.target.name == "item_max_price"
        ? e.target.value
        : product?.item_max_price || product?.item_price || 0;
    let narration =
      e.target.name == "narration" ? e.target.value : product?.narration || "";

    let alt_max_price =
      e.target.name == "alt_max_price"
        ? e.target.value
        : product?.alt_max_price || product?.alt_price || 0;

    let item_min_price =
      e.target.name == "item_min_price"
        ? e.target.value
        : product?.item_min_price || 0;
    let alt_min_price =
      e.target.name == "alt_min_price"
        ? e.target.value
        : product?.alt_min_price || 0;

    let rate =
      e.target.name == "rate"
        ? e.target.value
        : product?.rate || product?.item_price || 0;
    let base_rate = product?.base_rate || rate;
    let alt_price =
      e.target.name == "alt_price"
        ? e.target.value
        : product?.alt_price || product?.alt_price || 0;
    let alt_rate = product?.alt_rate || product?.alt_price || 0;
    let qty =
      e.target.name == "requested_qty"
        ? e.target.value
        : product.requested_qty || 1;
    // let grossAmt = parseFloat(parseFloat(rate) * parseFloat(qty)).toFixed(4);

    // let godownList = godown.map((x) => x.godown_id);
    // let godown_id =
    //   e.target.name == "godown_id"
    //     ? e.target.value
    //     : godownList.includes(Number(product?.godown_id))
    //     ? product?.godown_id
    //     : godownList.includes(Number(product?.item_godown))
    //     ? product?.item_godown
    //     : defaultGodown;

    let currentGodownList = godownRef.current.map((x) => Number(x.godown_id));

    let godown_id = defaultGodownRef.current;

    if (e.target.name === "godown_id" || product?.item_id) {
      const currentProductId = Number(product?.item_id || e?.item_id);

      const usedGodowns = formInputs.item_dtl
        .filter((item, index) => {
          if (index === parseInt(idx)) return false;
          if (!item.godown_id) return false;
          if ([2, 4].includes(Number(item.is_active))) return true;
          if (Number(item.item_id) === currentProductId) return true;
          return false;
        })
        .map((item) => Number(item.godown_id));

      const availableGodowns = currentGodownList.filter(
        (gid) => !usedGodowns.includes(Number(gid)),
      );

      let matchedGodown = null;
      let existingGodown = Number(product?.godown_id || product?.item_godown);

      if (existingGodown && availableGodowns.includes(existingGodown)) {
        matchedGodown = existingGodown;
      } else if (product?.item_godown_data?.length > 0) {
        let found = product.item_godown_data.find((g) =>
          availableGodowns.includes(Number(g.godown_id)),
        );
        if (found) {
          matchedGodown = Number(found.godown_id);
        }
      }

      godown_id =
        e.target.name === "godown_id"
          ? e.target.value
          : matchedGodown
            ? String(matchedGodown)
            : availableGodowns.length > 0
              ? availableGodowns[0]
              : "";
    }

    let alt_conv = product?.alt_conv;
    let base_uom = product?.base_uom || product?.item_unit;
    let alt_uom = product?.alt_uom || product?.alt_unit;
    let base_conv = parseFloat(product?.base_conv || 1);
    let uom =
      e.target.name == "uom"
        ? e.target.value
        : product.uom || product.base_uom || product?.item_unit;

    let alt_qty = product?.alt_conv || 1;

    alt_qty = parseFloat(alt_conv) / parseFloat(base_conv);

    if (e.target.name == "uom") {
      // qty = product.alt_qty;
      alt_price = alt_rate;
      rate = base_rate;
    }

    if (uom == alt_uom) {
      alt_qty =
        product.alt_conv == 1 ? parseFloat(base_conv) : base_conv / alt_conv;
      // rate = alt_price * alt_conv;
      rate = (alt_price * alt_conv).toFixed(4);
    } else if (uom === base_uom) {
      // alt_price = rate / alt_conv;
      alt_price = (rate / alt_conv).toFixed(4);
    }

    const grossAmt =
      uom === base_uom
        ? parseFloat(rate * qty).toFixed(4)
        : parseFloat(alt_price * qty).toFixed(4);
    // : parseFloat(
    //   rate * (parseFloat(alt_qty) * parseFloat(qty)).toFixed(2)
    // ).toFixed(4);
    let disc = e.target.name == "disc" ? e.target.value : product.disc || 0;
    let discAmt = parseFloat((grossAmt * parseFloat(disc)) / 100).toFixed(4);
    let prodDtl = {
      challan_details_id: product?.challan_details_id || "",
      item_id: product.item_id,
      is_active: product?.is_active,
      narration: narration,
      item_name: product.item_name,
      requested_qty: qty,
      rate: rate,
      disc: disc,
      // item_id: product.item_id,
      godown_id: godown_id,
      avail_qty: product?.avail_qty || "",
      billed_qty: product?.billed_qty || "",
      updatedAt: product?.updatedAt || "",
      amount: isNaN(grossAmt) ? 0 : grossAmt,
      disc_amt: isNaN(discAmt) ? 0 : discAmt,
      alt_conv: alt_conv,
      base_uom: base_uom,
      alt_uom: alt_uom,
      uom: uom,
      alt_price: alt_price,
      alt_rate: alt_rate,
      base_rate: base_rate,
      received_qty: product.received_qty,
      alt_qty: (parseFloat(alt_qty) * parseFloat(qty)).toFixed(4),
      updatedAt: product?.updatedAt,
      item_min_price: item_min_price,
      alt_min_price: alt_min_price,
      item_max_price: item_max_price,
      alt_max_price: alt_max_price,
    };
    let existProdDtl = [...formInputs.item_dtl];
    existProdDtl[idx] = prodDtl;
    setFormInputs((prevState) => {
      let newState = {
        ...prevState,
        item_dtl: existProdDtl,
      };
      return newState;
    });
  }

  const handleBarcodeInput = (item) => {
    setFormInputs((prev) => {
      let existItemIndex = prev.item_dtl.findIndex(
        (row) => row.item_id == item.item_id,
      );

      if (existItemIndex !== -1) {
        // Increment quantity in existing row
        setHighlightedRow(existItemIndex);
        setTimeout(() => {
          let currentQty = parseFloat(
            prev.item_dtl[existItemIndex].requested_qty || 0,
          );
          handleTableInputs(
            {
              target: { name: "requested_qty", value: currentQty + 1 },
            },
            existItemIndex,
          );
        }, 1);
        return prev;
      } else {
        // Add new item
        let emptyRowIndex = prev.item_dtl.findIndex((row) => !row.item_id);
        let newIdx =
          emptyRowIndex !== -1 ? emptyRowIndex : prev.item_dtl.length;

        setHighlightedRow(newIdx);

        setSelectedProduct((prevState) => {
          let newState = [...prevState];
          newState[newIdx] = item;
          return newState;
        });

        if (emptyRowIndex !== -1) {
          setTimeout(() => {
            handleTableInputs(
              {
                target: { name: "item_id", value: item },
              },
              emptyRowIndex,
            );
          }, 1);
          return prev;
        } else {
          // Add a new row to the end
          let updatedItemDtl = [...prev.item_dtl, itemDtl];
          setTimeout(() => {
            handleTableInputs(
              {
                target: { name: "item_id", value: item },
              },
              newIdx,
            );
          }, 1);
          return { ...prev, item_dtl: updatedItemDtl };
        }
      }
    });
  };

  const scanBarcode = (e) => {
    if (e) e.preventDefault();
    if (isSubmit) return;
    if (!barcode || barcode.trim().length < 2) return;

    setBarcodeLoading(true);
    $.post(
      `${config.apiUrl}/item/listItem`,
      JSON.stringify({
        paginate: 0,
        is_active: 1,
        barcode: barcode.trim(),
      }),
      (res) => {
        setBarcodeLoading(false);
        let list = res?.data?.list || [];
        if (list.length > 0) {
          playBarcodeSound(true);
          handleBarcodeInput(list[0]);
          setBarcode("");
          setTimeout(() => {
            if (barcodeRef.current) barcodeRef.current.focus();
          }, 200);
        } else {
          playBarcodeSound(false);
          Swal.fire({
            html: "Product not available of this barcode",
            icon: "error",
            confirmButtonText: "Close",
            allowEnterKey: true,
            allowEscapeKey: true,
            didOpen: () => {
              Swal.getConfirmButton().focus();
            },
          }).then(() => {
            setBarcode("");
            setTimeout(() => {
              if (barcodeRef.current) barcodeRef.current.focus();
            }, 200);
          });
        }
      },
    );
  };
  const validatePriceRangeOnBlur = (e, itemData) => {
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || 0;

    const idx = e.target.closest("tr").getAttribute("data-id");
    const currentItem = formInputs.item_dtl[idx];

    let minPrice = 0;
    let maxPrice = Infinity;

    if (name === "rate") {
      minPrice = parseFloat(currentItem.item_min_price) || 0;
      maxPrice = parseFloat(currentItem.item_max_price) || Infinity;
    } else if (name === "alt_price") {
      minPrice = parseFloat(currentItem.alt_min_price) || 0;
      maxPrice = parseFloat(currentItem.alt_max_price) || Infinity;
    }
    if (minPrice <= 0) {
      return; // Skip validation entirely
    }
    // Show warning message and adjust value if out of range
    if (minPrice > 0 && numericValue < minPrice) {
      Swal.fire({
        title: "Price Below Minimum",
        text: `Minimum price is ${minPrice}. Setting to minimum value.`,
        icon: "warning",
        timer: 4000,
      });
      e.target.value = minPrice.toString();
      handleTableInputs(e);
    }
    // else if (maxPrice < Infinity && numericValue > maxPrice) {
    //   Swal.fire({
    //     title: "Price Above Maximum",
    //     text: `Maximum price is ${maxPrice}. Setting to maximum value.`,
    //     icon: "warning",
    //     timer: 4000,
    //   });
    //   e.target.value = maxPrice.toString();
    //   handleTableInputs(e);
    // }
  };
  async function getAvailableItem(item_id, godown_id, idx) {
    if (item_id && godown_id) {
      await $.post(
        `${config.apiUrl}/godownStock/listGodownStock`,
        JSON.stringify({ item_id, godown_id }),
      ).done(function (res) {
        let avail_qty = 0;
        let billed_qty = 0;

        if (res?.data?.list?.length)
          avail_qty = res.data.list[0]?.avail_qty || 0;
        billed_qty = res.data.list[0]?.billed_qty || 0;
        setFormInputs((prevState) => {
          let existProdDtl = [...prevState.item_dtl];
          existProdDtl[idx] = {
            ...existProdDtl[idx],
            avail_qty: avail_qty,
            billed_qty: billed_qty,
          };
          let newState = {
            ...prevState,
            item_dtl: existProdDtl,
          };
          return newState;
        });
      });
    }
  }

  function handleItemCount(v, i) {
    if (v == "+") {
      if (formInputs.item_dtl[formInputs.item_dtl.length - 1].item_id == "") {
        Swal.fire({ html: "Please fill proper data." });
      } else {
        let existProdDtl = formInputs.item_dtl;
        existProdDtl[formInputs.item_dtl.length] = itemDtl;
        setFormInputs({ ...formInputs, item_dtl: existProdDtl });
      }
    } else if (v == "-") {
      if (formInputs.item_dtl.length == 1) {
        Swal.fire({ html: "Can't delete last row." });
      } else {
        let existProdDtl = formInputs.item_dtl.filter((v, idx) => {
          return idx != i;
        });
        setFormInputs({ ...formInputs, item_dtl: existProdDtl });
      }
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isZeroValueYes =
      formInputs.is_zero_value === 1 || formInputs.is_zero_value === "1";

    if (isZeroValueYes) {
      const allRatesNonZero = formInputs.item_dtl.every((item) => {
        const effectivePrice =
          item?.uom === item?.alt_uom ? item?.alt_price : item?.rate;
        const priceValue = parseFloat(effectivePrice);
        return priceValue > 0;
      });
      if (allRatesNonZero) {
        const result = await Swal.fire({
          title: "Zero Value Confirmation",
          html: "Your <b>Zero Value</b> is set to <b>Yes</b> but <b>none</b> of your products have zero rate.<br><br>Do you want to Edit the Challan?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, Edit Challan",
          cancelButtonText: "No",
          allowOutsideClick: false,
        });

        if (!result.isConfirmed) {
          return;
        }
      }
    }
    var grossamtval = parseFloat(totalRef.current.value.replace(/,/g, ""));
    if (grossamtval == 0) {
      if (formInputs.narration == "") {
        Swal.fire({ html: "Narration is Required" });
        return;
      }
    }

    let remainingAmount = grossamtval || 0;
    formInputs?.pay_dtl?.forEach((pay) => {
      if (pay.mode !== "Cash UGX") {
        remainingAmount -= parseFloat(pay.amt || 0);
      }
    });

    // const updatedPayments = formInputs?.pay_dtl?.map((pay) => {
    //     if (pay.mode === "Cash UGX") {
    //         let amount = parseFloat(remainingAmount) < 0 ? grossamtval : parseFloat(remainingAmount)
    //         return { ...pay, amt: amount || 0, conv_amt: amount || 0 };
    //     } else {
    //         return parseFloat(remainingAmount) < 0 ? { ...pay, amt: '', conv_amt: '' } : pay
    //     }
    // });

    const updatedPayments = formInputs?.pay_dtl?.map((pay) => {
      if (pay.mode === "Cash UGX") {
        let amount = parseFloat(remainingAmount);
        return { ...pay, amt: amount || 0, conv_amt: amount || 0 };
      } else {
        return pay;
      }
    });
    setFormInputs((prevState) => ({
      ...prevState,
      pay_dtl: updatedPayments,
    }));

    if (formInputs.item_dtl.length > 1) {
      formInputs.item_dtl = formInputs.item_dtl.filter((p) => p.item_id != "");
    }
    let isInvalid = await salesSchema.validateEdit(formInputs);
    if (isInvalid?.errors) {
      Swal.fire("", isInvalid.errors[0]);
      return;
    }

    formInputs.total_amount = removeMillionComma(totalRef.current.value);
    formInputs.discount_amount = discRef.current.value;

    setIsSubmit(true);
    let prod = [...formInputs.item_dtl];
    for (let i = 0; i < prod.length; i++) {
      let element = {};
      element = prod[i];
      if (element.uom == element.alt_uom) {
        let newProdDtl = {
          ...element,
          requested_qty: element.alt_qty,
          alt_qty: element.requested_qty,
        };
        prod[i] = newProdDtl;
      }
    }
    const isVerifyValue = userRole != 4 ? 1 : formInputs.is_verify;
    let newFormData = {
      ...formInputs,
      item_dtl: prod,
      pay_dtl: updatedPayments,
      is_verify: isVerifyValue,
      is_zero_value:
        formInputs.is_active == 4 ? "0" : formInputs?.is_zero_value,
    };
    if (isTemp) {
      newFormData = {
        ...newFormData,
        is_temp: true,
      };
    }

    try {
      let { data } = await axios.post(
        `${config.apiUrl}/challan/editChallan`,
        JSON.parse(JSON.stringify(newFormData).replace(/"\s+|\s+"/g, '"')),
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("inventory"))?.token,
          },
        },
      );
      await handleSccessShow();
      setResData(data);
      discRef.current.value = 0;
      totalRef.current.value = 0;
      setSelectedCustomer("");
      setSelectedUser("");
      setSelectedProduct([]);
      setDefaultGodown("");
      setFormInputs(() => {
        return { ...initialState, item_dtl: [{ ...itemDtl, godown_id: "" }] };
      });
      setIsSubmit(false);
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.response.data.data.message,
        confirmButtonText: "OK",
        allowEnterKey: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        focusConfirm: true,
      });
      setIsSubmit(false);
    }
  };

  useEffect(() => {
    if (!sale?.challan_id) return;
    const url = isTemp
      ? `${config2.apiUrl}/challan/listTempChallanDtl`
      : `${config2.apiUrl}/challan/listChallanDtl`;

    $.post(
      `${url}`,
      JSON.stringify({
        challan_id: sale?.challan_id,
        paginate: 0,
        list_type: 3,
        is_temp: true,
      }),
      function (res) {
        let prod = res?.data?.list || [];

        for (let i = 0; i < prod?.length; i++) {
          let element = prod[i];
          if (element.uom === element.base_uom) {
            prod[i] = {
              ...element,
              amount: element.requested_qty * element.rate,
            };
          } else {
            prod[i] = {
              ...element,

              requested_qty: element.alt_qty,
              alt_qty: element.requested_qty,
              amount: element.alt_qty * element.alt_price,
            };
          }
        }

        let itemDtl = prod.map((item) => ({
          challan_details_id: item?.challan_details_id,
          item_id: item?.item_id,
          narration: item?.narration,
          item_name: item?.mst_item?.item_name,
          requested_qty: item?.requested_qty,
          avail_qty: "",
          billed_qty: "",
          rate: item?.rate,
          amount: Number(item?.amount),
          disc: 0,
          disc_amt: 0,
          godown_id: item?.godown_id,
          is_active: item?.is_active,
          updatedAt: item?.updatedAt,
          alt_conv: item?.alt_conv,
          base_uom: item?.base_uom,
          alt_uom: item?.alt_uom,
          uom: item?.uom,
          alt_qty: item?.alt_qty,
          alt_price: item?.alt_price,
          alt_rate: item?.alt_rate,
          base_rate: item?.base_rate,
          received_qty:
            item?.uom == item?.alt_uom
              ? (item.alt_received_qty ?? item?.received_qty)
              : item?.received_qty,
          updatedAt: item?.updatedAt,
          item_min_price: item?.mst_item?.item_min_price,
          alt_min_price: item?.mst_item?.alt_min_price,
          item_max_price: item?.mst_item?.item_price,
          alt_max_price: item?.mst_item?.alt_price,
        }));

        setSelectedProduct(itemDtl);
        setSelectedCustomer(sale?.mst_cust);

        setFormInputs((prevState) => ({
          challan_id: sale?.challan_id,
          is_active: sale?.is_active,
          challan_date: sale?.challan_date
            ? moment(sale?.challan_date).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
          branch_id: sale?.branch_id,
          cust_id: sale?.cust_id,
          inv_no: sale?.inv_no,
          payment_mode_id: sale?.payment_mode_id || 1,
          item_dtl: itemDtl,
          narration: sale?.narration || "",
          is_zero_value: sale?.is_zero_value ?? "",
          vehicle_no: sale?.vehicle_no || "",
          pay_dtl: sale?.pay_dtl
            ? typeof sale.pay_dtl === "string"
              ? JSON.parse(sale.pay_dtl)
              : sale.pay_dtl
            : prevState.pay_dtl,
          is_verify: sale?.is_verify || 0,
          voucher_id: sale?.voucher_id || "",
        }));
      },
    );
  }, [sale?.challan_id]);

  useEffect(function () {
    focus.current[0].cust_id.focus();
  }, []);

  useEffect(
    function () {
      calculateTotal();
      for (let i = 0; i < formInputs.item_dtl.length; i++) {
        if (
          formInputs.item_dtl[i].avail_qty === "" ||
          formInputs.item_dtl[i].billed_qty === ""
        ) {
          getAvailableItem(
            formInputs.item_dtl[i].item_id,
            formInputs.item_dtl[i].godown_id,
            i,
          );
        }
      }
    },
    [formInputs],
  );

  const [showPayDtl, setShowPayDtl] = useState(false);
  const handlePayDtl = () => {
    setShowPayDtl((prevState) => !prevState);
  };
  function getPaymentMode() {
    const paymentModes = formInputs.pay_dtl.filter(
      (pay) => pay.amt !== "" && pay.amt !== undefined && pay.amt > 0,
    );

    if (paymentModes.length === 0) {
      return "Cash UGX";
    } else if (paymentModes.length === 1) {
      return paymentModes[0].mode;
    } else {
      return "Multiple";
    }
  }
  useEffect(() => {
    if (accessCode == 1 && userRole == 4) {
      setShowValidationModal(true);
    }
  }, [accessCode, userRole]);

  const handleValidationInputChange = (e) => {
    const { name, value } = e.target;
    setValidationInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [validateLoader, setValidateLoader] = useState(false);
  const handleValidate = async () => {
    if (!validationInputs.user_id) {
      Swal.fire("", "Please select a User");
      return;
    }
    if (!validationInputs.access_code) {
      Swal.fire("", "Please enter Access Code");
      return;
    }
    setValidateLoader(true);
    try {
      const response = await axios.post(
        `${config.apiUrl}/user/validateAccessCode`,
        {
          user_id: validationInputs.user_id,
          access_code: validationInputs.access_code,
        },
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("inventory"))?.token,
          },
        },
      );

      if (response.data.status === 200) {
        setIsValidated(true);
        setShowValidationModal(false);
        Swal.fire(
          "Success",
          "Validation successful. You can now edit.",
          "success",
        );
        setValidateLoader(false);
        setFormInputs((prev) => ({
          ...prev,
          is_verify: 1,
        }));
      } else {
        Swal.fire("Error", response.data.message || "Validation failed");
        setFormInputs((prev) => ({
          ...prev,
          is_verify: 0,
        }));
        setValidateLoader(false);
      }
    } catch (error) {
      console.log("error.responseerror.response", error.response);
      Swal.fire(
        "Error",
        error.response?.data?.data?.message || "Validation failed",
      );
      setFormInputs((prev) => ({
        ...prev,
        is_verify: 0,
      }));
      setValidateLoader(false);
    }
  };
  console.log("jhsjajjhjdhsjfs", formInputs?.is_zero_value);
  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2 position-relative pb-8">
          <Header />
          <Breadcrumb path={["Challan", "Edit Challan"]} />

          <main className="bg-white rounded-2" id="saleAdd">
            <div className="container-fluid p-2 position-relative">
              <Link
                to={isTemp ? "/temp-challan" : "/challan"}
                className="position-absolute text-decoration-none small"
                style={{ top: "-1.5rem", right: "0" }}
                state={{
                  backToCurrent: page,
                  appliedFilter: filter,
                  filterDisplay: currentFilterState,
                  pageSize: location.state?.pageSize || 10,
                }}
              >
                Go Back to List
              </Link>
              <form
                className="gx-4 gy-2"
                autoComplete="off"
                onSubmit={handleSubmit}
              >
                <div className="row gx-3 mb-2">
                  <div className="col-md-3">
                    <label htmlFor="challan_no">Challan No</label>
                    <input
                      type="text"
                      className="form-control"
                      id="challan_no"
                      value={sale?.challan_no || ""}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="cust_id">
                      Customer Name
                      <span className="text-danger">*</span>
                    </label>
                    <CommonAsyncSelect
                      ref={(el) => (focus.current[0].cust_id = el)}
                      isDisabled
                      noOptionsMessage={() => null}
                      placeholder="Enter atleast 3 character"
                      getOptionLabel={(o) => o.customer_name}
                      getOptionValue={(o) => o.cust_id}
                      // isDisabled={false}
                      loadOptions={async (inputValue, callback) => {
                        if (inputValue.toString().length > 2) {
                          await $.post(
                            `${config.apiUrl}/customer/listCustomer`,
                            JSON.stringify({
                              paginate: 0,
                              is_active: 1,
                              customer_name: inputValue,
                            }),
                            function (res) {
                              callback(res?.data?.list || []);
                            },
                          );
                        } else {
                          callback([]);
                        }
                      }}
                      value={selectedCustomer}
                      onChange={(e) => {
                        setSelectedCustomer(e);
                        setFormInputs((prevState) => {
                          let newState = {
                            ...prevState,
                            cust_id: e.cust_id,
                            payment_mode_id:
                              e?.is_cash_only == 1
                                ? 1
                                : formInputs?.payment_mode_id,
                          };
                          return newState;
                        });
                        // focus.current[0].inv_no.focus();
                        focus.current[0].default_godown.focus();
                      }}
                      components={{
                        IndicatorsContainer: () => null,
                      }}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          minHeight: "30px",
                        }),
                        valueContainer: (baseStyles) => ({
                          ...baseStyles,
                          paddingTop: "0px",
                          paddingBottom: "0px",
                          paddingLeft: "4px",
                          paddingRight: "4px",
                          minHeight: "30px",
                        }),
                        input: (baseStyles) => ({
                          ...baseStyles,
                          padding: "0px",
                          margin: "0px",
                          lineHeight: "1.2",
                          overflow: "visible",
                        }),
                        dropdownIndicator: (baseStyles) => ({
                          ...baseStyles,
                          padding: "0px",
                        }),
                        option: (baseStyles) => ({
                          ...baseStyles,
                          paddingTop: "4px",
                          paddingBottom: "4px",
                        }),
                      }}
                      classNamePrefix="react-select"
                      tabSelectsValue
                    />
                  </div>
                  {multiVoucher == 1 ? (
                    <div className="col-md-3">
                      <label htmlFor="voucher_id">Voucher Type</label>
                      <select
                        className="form-select"
                        value={formInputs.voucher_id}
                        name="voucher_id"
                        disabled
                        onChange={(e) => {
                          handleInputs(e);
                        }}
                      >
                        <option value="" hidden>
                          Select...
                        </option>
                        {props?.voucherList &&
                          props?.voucherList.map((list) => (
                            <option key={list.voucher_id} value={list.voucher_id}>
                              {`${list.voucher_name}${
                                list.voucher_series || list.current_value
                                  ? ` (${list.voucher_series || ""}${list.current_value ?? ""})`
                                  : ""
                              }${list.sales_ledger ? ` - ${list.sales_ledger}` : ""}`}
                            </option>
                          ))}
                      </select>
                    </div>
                  ) : null}
                  {/*<div className="col-md">*/}
                  {/*    <label htmlFor="inv_no">*/}
                  {/*        Invoice No <span className="text-danger">*</span>*/}
                  {/*    </label>*/}
                  {/*    <input*/}
                  {/*        ref={(el) => (focus.current[0].inv_no = el)}*/}
                  {/*        type="text"*/}
                  {/*        className="form-control"*/}
                  {/*        name="inv_no"*/}
                  {/*        value={formInputs.inv_no}*/}
                  {/*        onChange={handleInputs}*/}
                  {/*    />*/}
                  {/*</div>*/}
                  <div className="col-md-3">
                    <label htmlFor="default_godown">Default Godown</label>
                    <select
                      ref={(el) => (focus.current[0].default_godown = el)}
                      className="form-select"
                      value={formInputs.defaultGodown}
                      onChange={(e) => {
                        setDefaultGodown(e.target.value);
                        // setFormInputs(prevState => {
                        //     let newState = { ...prevState }
                        //     let itemDtl = [...newState.item_dtl]
                        //     itemDtl = itemDtl.map(item => {
                        //         return { ...item, godown_id: e.target.value }
                        //     })
                        //     return {
                        //         ...newState, item_dtl: itemDtl,
                        //     }
                        // });
                      }}
                      disabled={sale?.is_active == 4}
                    >
                      <option value="" hidden>
                        Select...
                      </option>
                      {godown &&
                        godown.map((list) => (
                          <option value={list.godown_id}>
                            {list.godown_name}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="challan_date">
                      Challan Date <span className="text-danger">*</span>
                    </label>
                    <input
                      // min={moment().format("YYYY-MM-DD")}
                      min={userBackDate()}
                      max={moment().format("YYYY-MM-DD")}
                      ref={(el) => (focus.current[0].challan_date = el)}
                      type="date"
                      className="form-control"
                      name="challan_date"
                      value={formInputs.challan_date}
                      onChange={(e) => {
                        handleInputs(e);
                      }}
                      disabled={sale?.is_active == 4}
                      onKeyDown={(e) => {
                        if (e.key == "Tab") {
                          return;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="payment_mode_id">Payment Mode</label>
                    <select
                      ref={(el) => (focus.current[0].payment_mode_id = el)}
                      className="form-select"
                      name="payment_mode_id"
                      value={formInputs.payment_mode_id}
                      onChange={(e) => {
                        const newPaymentMode = e.target.value;
                        setFormInputs((prevState) => {
                          let newState = {
                            ...prevState,
                            payment_mode_id: newPaymentMode,
                          };

                          if (newPaymentMode === "2") {
                            newState.is_zero_value = "0";
                          } else {
                            newState.is_zero_value = "0";
                          }

                          return newState;
                        });
                      }}
                      disabled={
                        selectedCustomer?.is_cash_only == 1 ||
                          JSON.parse(localStorage.getItem("inventory")).userData
                            ?.role_id == 7
                          ? true
                          : false
                      }
                    >
                      {config.paymentMode &&
                        config.paymentMode.map((list) => (
                          <option key={list.value} value={list.value}>{list.label}</option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="vehicle_no">Vehicle No</label>
                    <input
                      ref={(el) => (focus.current[0].vehicle_no = el)}
                      type="text"
                      className="form-control"
                      name="vehicle_no"
                      value={formInputs.vehicle_no}
                      maxLength={20}
                      onChange={handleInputs}
                      onKeyDown={inputAlphanumeric}
                      disabled={sale?.is_active == 4}
                    />
                  </div>
                  {formInputs.payment_mode_id == "2" && (
                    <div className="col-md-3">
                      <label htmlFor="is_zero_value">Zero Valued</label>
                      <select
                        name="is_zero_value"
                        value={formInputs.is_zero_value}
                        onChange={handleInputs}
                        className="form-select"
                        // disabled
                        disabled={formInputs.is_active == 4}
                      >
                        {/* <option value="">NA</option> */}
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </div>
                  )}
                  <div className="col-md-3">
                    <label htmlFor="narration">Narration</label>
                    <textarea
                      ref={(el) => (focus.current[0].narration = el)}
                      type="text"
                      className="form-control"
                      name="narration"
                      value={formInputs.narration}
                      onChange={handleInputs}
                      maxLength={100}
                      onKeyDown={inputAlphanumeric}
                      disabled={sale?.is_active == 4}
                    />
                  </div>
                </div>

                <div className="row gx-3 gy-2">
                  <div className="col-12">
                    <table
                      className="table mt-3 rounded"
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>
                            <div className="d-flex align-items-center gap-2">
                              Item Name <span className="text-danger">*</span>
                              {sale.is_active != 4 && (
                                <div className="position-relative d-flex align-items-center">
                                  <input
                                    ref={barcodeRef}
                                    type="text"
                                    className="form-control form-control-sm"
                                    style={{ width: "120px" }}
                                    placeholder="Scan Barcode"
                                    value={barcode}
                                    onChange={(e) => setBarcode(e.target.value)}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        scanBarcode(e);
                                      }
                                    }}
                                  />
                                  {barcodeLoading && (
                                    <div
                                      className="position-absolute end-0 me-2"
                                      style={{ zIndex: 10 }}
                                    >
                                      <span
                                        className="spinner-border spinner-border-sm text-primary"
                                        role="status"
                                        aria-hidden="true"
                                        style={{
                                          width: "0.8rem",
                                          height: "0.8rem",
                                        }}
                                      ></span>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </th>
                          <th>
                            Godown <span className="text-danger">*</span>
                          </th>
                          <th>UOM</th>
                          <th width="80px">
                            {displayQty === "physical"
                              ? "Physical Qty"
                              : displayQty === "saleable"
                                ? "Saleable"
                                : displayQty === "both"
                                  ? "Physical (Saleable)"
                                  : "Avl. Qty"}
                          </th>
                          <th>
                            Reqd. Qty <span className="text-danger">*</span>
                          </th>
                          <th>Supp. Qty</th>
                          <th>
                            Rate <span className="text-danger">*</span>
                          </th>
                          {/*<th>Disc</th>*/}
                          <th>Amount</th>
                          {/*<th>Disc. Amt</th>*/}
                          {sale.is_active != 4 ? <th>Actions</th> : null}
                        </tr>
                      </thead>
                      <tbody>
                        {formInputs.item_dtl &&
                          formInputs.item_dtl.map((v, i) => {
                            return (
                              <tr
                                key={i}
                                data-id={i}
                                className={
                                  highlightedRow === i ? "scan-highlight" : ""
                                }
                                onClick={() => setHighlightedRow(i)}
                              >
                                <td style={{ width: "370px" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      // justifyContent: "center",
                                      alignItems: "center",
                                      gap: "1px",
                                    }}
                                  >
                                    <CommonAsyncSelect
                                      ref={(el) =>
                                        (focus.current[0][`prod_id_${i}`] = el)
                                      }
                                      autoFocus={true}
                                      getOptionLabel={(o) => o.item_name}
                                      isDisabled={v.received_qty > 0}
                                      placeholder="Enter atleast 3 character"
                                      getOptionValue={(o) => o.item_id}
                                      noOptionsMessage={() => null}
                                      defaultOptions={itemList}
                                      isLoading={itemLoading}
                                      loadOptions={async (
                                        inputValue,
                                        callback,
                                      ) => {
                                        let currentList = itemList;
                                        if (inputValue) {
                                          const search = inputValue
                                            .toLowerCase()
                                            .trim();
                                          currentList = itemList.filter(
                                            (item) =>
                                              item.item_name?.toLowerCase().includes(search) ||
                                              item.barcode?.toLowerCase().includes(search) ||
                                              item.SKU?.toLowerCase().includes(search)
                                          );
                                        }
                                        const filteredList = currentList.filter(
                                          (item) => {
                                            const usedCount =
                                              formInputs.item_dtl.filter(
                                                (row, idx) =>
                                                  idx !== i &&
                                                  row.item_id ===
                                                    item.item_id &&
                                                  row.godown_id,
                                              ).length;
                                            return usedCount < godown.length;
                                          },
                                        );
                                        callback(filteredList);
                                      }}
                                      // filterOption={(candidate, input) => {
                                      //   if (
                                      //     selectedProduct.find(
                                      //       (p) => p.item_id === candidate.value
                                      //     )
                                      //   )
                                      //     return false;
                                      //   else return true;
                                      // }}
                                      value={
                                        selectedProduct.find(
                                          (p) =>
                                            p.item_id ==
                                            formInputs.item_dtl[i].item_id,
                                        ) || null
                                      }
                                      onChange={async (e) => {
                                        if (e?.item_id) {
                                          await $.post(
                                            `${config.apiUrl}/item/listItem`,
                                            JSON.stringify({
                                              paginate: 0,
                                              is_active: 1,
                                              item_id: e.item_id,
                                            }),
                                            (res) => {
                                              const fullItem =
                                                res?.data?.list?.[0] || e;
                                              setSelectedProduct(
                                                (prevState) => {
                                                  let newState = [...prevState];
                                                  newState[i] = fullItem;
                                                  return newState;
                                                },
                                              );
                                              handleTableInputs(
                                                {
                                                  target: {
                                                    name: "item_id",
                                                    value: fullItem,
                                                  },
                                                },
                                                i,
                                              );
                                              if (
                                                itemLevelNarration === 1 &&
                                                focus.current[`narration${i}`]
                                              ) {
                                                setTimeout(
                                                  () =>
                                                    focus.current[
                                                      `narration${i}`
                                                    ].focus(),
                                                  0,
                                                );
                                              }
                                              focus.current[0][
                                                `requested_qty_${i}`
                                              ].focus();
                                            },
                                          );
                                        }
                                      }}
                                      components={{
                                        IndicatorsContainer: () => null,
                                      }}
                                      styles={{
                                        control: (baseStyles, state) => ({
                                          ...baseStyles,
                                          minHeight: "0px",
                                        }),
                                        valueContainer: (
                                          baseStyles,
                                          state,
                                        ) => ({
                                          ...baseStyles,
                                          paddingTop: "0px",
                                          paddingBottom: "0px",
                                          width: "400px",
                                        }),
                                        input: (baseStyles, state) => ({
                                          ...baseStyles,
                                          paddingTop: "0px",
                                          paddingBottom: "0px",
                                          marginTop: "0px",
                                          marginBottom: "0px",
                                          gridTemplateColumns: "0 100%",
                                        }),
                                        dropdownIndicator: (
                                          baseStyles,
                                          state,
                                        ) => ({
                                          ...baseStyles,
                                          paddingTop: "0px",
                                          paddingBottom: "0px",
                                        }),
                                        option: (baseStyles, state) => ({
                                          ...baseStyles,
                                          paddingTop: "0px",
                                          paddingBottom: "0px",
                                        }),
                                      }}
                                      classNamePrefix="react-select"
                                      tabSelectsValue
                                    />
                                    {formInputs.item_dtl[i]?.item_id ? (
                                      <Tippy content="View Item">
                                        <div>
                                          {" "}
                                          <span
                                            className=""
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleItemView(v)}
                                          >
                                            <BiInfoCircle size={20} />
                                          </span>
                                        </div>
                                      </Tippy>
                                    ) : null}
                                  </div>
                                  {itemLevelNarration == 1 ? (
                                    <textarea
                                      ref={(el) => {
                                        if (el)
                                          focus.current[`narration${i}`] = el;
                                      }}
                                      placeholder="Item Narration"
                                      type="text"
                                      className="form-control mt-1"
                                      name={"narration"}
                                      value={v?.narration}
                                      maxLength={100}
                                      disabled={
                                        !formInputs.item_dtl[i]?.item_id
                                      }
                                      onChange={handleTableInputs}
                                    />
                                  ) : null}
                                </td>
                                <td width="120px">
                                  <select
                                    className="form-select"
                                    name="godown_id"
                                    value={v.godown_id}
                                    onChange={(e) => {
                                      handleTableInputs(e);
                                      getAvailableItem(
                                        v.item_id,
                                        e.target.value ||
                                          v?.godown_id ||
                                          defaultGodown,
                                        i,
                                      );
                                    }}
                                    disabled={
                                      // (is_active ==4  &&   formInputs.is_zero_value != 1 ) ?

                                      v.is_active == 2 ||
                                      v?.is_active == 4 ||
                                      !formInputs.item_dtl[i]?.item_id
                                    }
                                  >
                                    <option value="" hidden>
                                      Select...
                                    </option>
                                    {/* {godown &&
                                      godown.map((list) => (
                                        <option value={list.godown_id}>
                                          {list.godown_name}
                                        </option>
                                      ))} */}
                                    {godown
                                      .filter((g) => {
                                        const godownId = Number(g.godown_id);
                                        const prodBlocked =
                                          blockedByProduct[
                                            Number(v?.item_id)
                                          ] || [];
                                        const isBlocked =
                                          globalBlocked.includes(godownId) ||
                                          prodBlocked.includes(godownId);

                                        return (
                                          !isBlocked ||
                                          Number(v?.godown_id) === godownId
                                        );
                                      })
                                      .map((list) => (
                                        <option
                                          key={list.godown_id}
                                          value={list.godown_id}
                                        >
                                          {list.godown_name}
                                        </option>
                                      ))}
                                  </select>
                                </td>
                                <td style={{ width: "90px" }}>
                                  {v?.alt_uom != null && v?.alt_uom != "" && (
                                    <select
                                      id=""
                                      name="uom"
                                      value={v?.uom}
                                      onChange={handleTableInputs}
                                      disabled={
                                        v.is_active == 4 || v.received_qty > 0
                                      }
                                      className="form-select"
                                    >
                                      {[v.base_uom, v.alt_uom].map(
                                        (ele, ind) => (
                                          <option value={ele}>{ele}</option>
                                        ),
                                      )}
                                    </select>
                                  )}
                                </td>
                                <td
                                  valign=""
                                  align="center"
                                  style={{ width: "90px" }}
                                >
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    disabled
                                    name="requested_qty"
                                    // value={v.avail_qty}
                                    value={
                                      displayQty === "physical"
                                        ? v.avail_qty // physical
                                        : displayQty === "saleable"
                                          ? v.billed_qty // saleable
                                          : displayQty === "both"
                                            ? `${v.avail_qty} (${v.billed_qty})`
                                            : v.avail_qty
                                    }
                                  />
                                </td>
                                <td style={{ width: "90px" }}>
                                  <input
                                    ref={(el) =>
                                      (focus.current[0][`requested_qty_${i}`] =
                                        el)
                                    }
                                    type="text"
                                    className="form-control text-end"
                                    name="requested_qty"
                                    value={v.requested_qty}
                                    maxLength={6}
                                    onChange={handleTableInputs}
                                    onKeyDown={(e) => {
                                      if (e.key == "Enter") {
                                        e.preventDefault();
                                        if (v.is_active != 4) {
                                          handleItemCount("+", i);
                                        }
                                      } else {
                                        inputfourDigitDeciaml(e);
                                      }
                                    }}
                                    required
                                    onFocus={(e) =>
                                      setTimeout(() => {
                                        e.target.select();
                                      }, 50)
                                    }
                                    disabled={
                                      v.is_active == 4 ||
                                      !formInputs.item_dtl[i]?.item_id ||
                                      v.received_qty > 0
                                    }
                                  />
                                  {v?.alt_uom != null && v?.alt_uom != "" && (
                                    <span
                                      className="text-right"
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      <TruncatedTextWithTooltip
                                        text={uomConversionUnit(v)}
                                      />
                                    </span>
                                  )}
                                </td>
                                <td style={{ width: "90px" }}>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    name="received_qty"
                                    value={v?.received_qty}
                                    disabled
                                  />
                                </td>
                                <td style={{}}>
                                  <CustomCurrencyInput
                                    maxDecimal={4}
                                    currencyFormat="US"
                                    // style={{ width: "80px" }}
                                    value={
                                      v?.uom == v?.alt_uom
                                        ? v?.alt_price
                                        : v?.rate
                                    }
                                    name={
                                      v?.uom == v?.alt_uom
                                        ? "alt_price"
                                        : "rate"
                                    }
                                    maxDigit={12}
                                    className="form-control text-end"
                                    disabled={
                                      formInputs?.is_zero_value == 1
                                        ? false
                                        : false ||
                                          !formInputs.item_dtl[i]?.item_id ||
                                          v.received_qty > 0
                                    }
                                    onKeyDown={(e) => {
                                      if (e.key == "Enter") {
                                        e.preventDefault();
                                        handleItemCount("+", i);
                                      } else {
                                        inputOnlyNumber(e);
                                      }
                                      {
                                        v?.alt_uom != null &&
                                          v?.alt_uom != "" && (
                                            <span
                                              className="text-right"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {uomConversionUnit(v)}
                                            </span>
                                          );
                                      }
                                    }}
                                    onBlur={(e) =>
                                      validatePriceRangeOnBlur(e, v)
                                    }
                                    onFocus={(e) =>
                                      setTimeout(() => {
                                        e.target.select();
                                      }, 50)
                                    }
                                    onChange={(val) => {
                                      handleTableInputs({
                                        target: {
                                          name:
                                            v?.uom == v?.alt_uom
                                              ? "alt_price"
                                              : "rate",
                                          value: val,
                                        },
                                      });
                                    }}
                                  />
                                  {/* <input
                                    // ref={el => focus.current[0][`base_price_${i}`] = el}
                                    disabled={
                                      formInputs?.is_zero_value == 1
                                        ? false
                                        : false ||
                                          !formInputs.item_dtl[i]?.item_id ||
                                          v.received_qty > 0
                                    }
                                    type="text"
                                    className="form-control text-end"
                                    name={
                                      v?.uom == v?.alt_uom ? "alt_price" : "rate"
                                    }
                                    value={
                                      v?.uom == v?.alt_uom
                                        ? v?.alt_price
                                        : v?.rate
                                    }
                                    maxLength={12}
                                    // value={millionComma(v.rate)}
                                    onChange={handleTableInputs}
                                    onKeyDown={(e) => {
                                      if (e.key == "Enter") {
                                        e.preventDefault();
                                        if (
                                          v.is_active != 4 &&
                                          sale.is_active != 2
                                        ) {
                                          handleItemCount("+", i);
                                        }
                                      } else {
                                        inputOnlyNumber(e);
                                      }
                                    }}
                                    required
                                    onBlur={(e) => validatePriceRangeOnBlur(e, v)}
                                    onFocus={(e) =>
                                      setTimeout(() => {
                                        e.target.select();
                                      }, 50)
                                    }
                                  /> */}
                                  {/* {v?.alt_uom != null && v?.alt_uom != "" && (
                                    <span style={{ whiteSpace: "nowrap" }}>
                                      {`Per (`}
                                      <TruncatedTextWithTooltip text={v?.base_uom} />
                                      {`)`}
                                    </span>
                                  )} */}
                                  {v?.alt_uom != null &&
                                    v?.alt_uom !== "" &&
                                    (v?.uom == v?.alt_uom ? (
                                      <span
                                        style={{
                                          wordBreak: "break-all",
                                          fontSize: "10px",
                                        }}
                                      >
                                        {`( ${v?.rate} Per `}
                                        <TruncatedTextWithTooltip
                                          text={uomConversion(v)}
                                        />
                                        {`)`}
                                      </span>
                                    ) : (
                                      <span
                                        style={{
                                          wordBreak: "break-all",
                                          fontSize: "10px",
                                        }}
                                      >
                                        {`(${v?.alt_price} Per `}
                                        <TruncatedTextWithTooltip
                                          text={uomConversion(v)}
                                        />
                                        {`)`}
                                      </span>
                                    ))}
                                </td>
                                {/*<td>
                                                          <input
                                                              // ref={el => focus.current[0][`base_price_${i}`] = el}
                                                              type="text"
                                                              className="form-control text-end"
                                                              name="disc"
                                                              value={v.disc}
                                                              onChange={handleTableInputs}
                                                              onKeyDown={(e) => {
                                                                  if (e.key == "Enter") {
                                                                      e.preventDefault();
                                                                      handleItemCount("+", i);
                                                                  } else {
                                                                      inputOnlyNumber(e);
                                                                  }
                                                              }}
                                                          />
                                                      </td>*/}
                                <td>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    name="amount"
                                    value={millionComma(v?.amount)}
                                    disabled
                                  />
                                </td>
                                {/*<td>
                                                          <input
                                                              type="text"
                                                              className="form-control text-end"
                                                              name="disc_amt"
                                                              value={v.disc_amt}
                                                              disabled
                                                          />
                                                      </td>*/}
                                {v.is_active !== 4 && (
                                  <td
                                    style={{
                                      width: "80px",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    {/* {sale.is_active !== 2 && ( */}
                                    <img
                                      src={addIcon}
                                      style={{
                                        width: "17px",
                                        height: "17px",
                                      }}
                                      className="img-fluid m-1"
                                      alt="add"
                                      role="button"
                                      onClick={() => handleItemCount("+", i)}
                                    />
                                    {/* )} */}

                                    {(v.received_qty <= 0 ||
                                      v.is_active != 2) && (
                                      <img
                                        src={deleteIcon}
                                        style={{
                                          width: "17px",
                                          height: "17px",
                                        }}
                                        className="img-fluid m-1"
                                        alt="delete"
                                        role="button"
                                        onClick={() => handleItemCount("-", i)}
                                      />
                                    )}
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="col-12 mt-2">
                    {(error || success) && (
                      <div
                        className={`alert alert-${
                          error ? "danger" : "success"
                        } py-2 small`}
                        role="alert"
                      >
                        {error || success || ""}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 position-absolute bottom-0 start-0 end-0">
                  <div
                    className="row rounded px-2 py-3"
                    style={{ background: "#F4F7FE" }}
                  >
                    <div className="col-md-3">
                      <label htmlFor="totalRef">Gross Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="totalRef"
                        ref={totalRef}
                        disabled
                      />
                    </div>
                    <div className="col d-none">
                      <label htmlFor="discRef">Discount Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="discRef"
                        ref={discRef}
                        disabled
                      />
                    </div>
                    <div className="col d-none">
                      <label htmlFor="finalRef">Final Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="finalRef"
                        value={parseFloat(
                          Number(totalRef.current.value) -
                            Number(discRef.current.value),
                        ).toFixed(4)}
                        disabled
                      />
                    </div>
                    <div className="col d-flex mt-auto justify-content-end">
                      <div
                        style={{
                          border: "1px solid gray",
                          height: "37px",
                          minWidth: "200px",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <b className="me-2"> {getPaymentMode()} </b> :{" "}
                        {totalValue}
                      </div>
                      <button
                        type="button"
                        onClick={handlePayDtl}
                        className="text-primary mt-1 me-4 border border-0 bg-transparent"
                      >
                        <BiCreditCard size={32} role="button" />
                      </button>
                      {accessCode == 1 && userRole == 4 ? (
                        <>
                          {formInputs?.is_verify == 1 && (
                            <button
                              className="ms-4 btn btn-primary"
                              type="submit"
                              disabled={isSubmit}
                              onClick={handleSubmit}
                            >
                              {isSubmit && (
                                <span className="spinner-border spinner-border-sm me-2"></span>
                              )}
                              Submit
                            </button>
                          )}

                          {formInputs?.is_verify == 0 && (
                            <button
                              className="ms-4 btn btn-primary rounded-2"
                              onClick={() => setShowValidationModal(true)}
                            >
                              Validate Access Code
                            </button>
                          )}
                        </>
                      ) : (
                        <button
                          className="ms-4 btn btn-primary"
                          type="submit"
                          disabled={isSubmit}
                          onClick={handleSubmit}
                        >
                          {isSubmit && (
                            <span className="spinner-border spinner-border-sm me-2"></span>
                          )}
                          Submit
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <ApiSuccessModal
        showSccess={showSccess}
        handleSccessClose={handleSccessClose}
        handleSccessShow={handleSccessShow}
        resData={resData}
        createNewButtonText="Challan"
        navigateToList={isTemp ? "/temp-challan" : "/challan"}
        navigateCreateNew={`/challan/add`}
        headerMsg={resData?.status == 200 ? "Success" : "Error"}
        challanId={sale?.challan_no || "N/A"}
        qrImg={resData?.data?.png}
        printId={sale?.challan_id}
        displayEditBtn={true}
      />

      {showPayDtl && (
        <PayDtlCard
          cardMode="edit"
          showPayDtl={showPayDtl}
          handlePayDtl={handlePayDtl}
          formInputs={formInputs}
          setFormInputs={setFormInputs}
          grossTotal={removeMillionComma(totalRef.current.value)}
        />
      )}

      {/* Validation Modal */}
      <Modal
        show={showValidationModal}
        onHide={() => setShowValidationModal(false)}
        backdrop="static"
        size="lg"
        keyboard={false}
        dialogClassName="access-validation-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Access Validation Required</Modal.Title>
        </Modal.Header>
        <div className="p-3">
          <div className="mb-3">
            <label htmlFor="user_id" className="form-label">
              User <span className="text-danger">*</span>
            </label>
            <CommonAsyncSelect
              noOptionsMessage={() => null}
              placeholder="Enter atleast 3 character"
              getOptionLabel={(o) => o.user_name}
              getOptionValue={(o) => o.user_id}
              isDisabled={false}
              loadOptions={async (inputValue, callback) => {
                if (inputValue.toString().length > 2) {
                  await $.post(
                    `${config.apiUrl}/user/searchUser`,
                    JSON.stringify({
                      paginate: 0,
                      is_active: 1,
                      user_name: inputValue,
                    }),
                    function (res) {
                      callback(res?.data?.list || []);
                    },
                  );
                } else {
                  callback([]);
                }
              }}
              value={selectedUser}
              isClearable={true}
              onChange={(e) => {
                if (e) {
                  setSelectedUser(e);
                  setValidationInputs((prevState) => {
                    let newState = {
                      ...prevState,
                      user_id: e.user_id,
                    };
                    return newState;
                  });
                } else {
                  setSelectedUser("");
                  setValidationInputs((prevState) => {
                    let newState = {
                      ...prevState,
                      user_id: "",
                    };
                    return newState;
                  });
                }
              }}
              components={{
                IndicatorsContainer: () => null,
              }}
              menuPosition={"fixed"}
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  minHeight: "30px !important",
                }),
                valueContainer: (baseStyles) => ({
                  ...baseStyles,
                  paddingTop: "0px !important",
                  paddingBottom: "0px !important",
                  paddingLeft: "4px !important",
                  paddingRight: "4px !important",
                  minHeight: "30px !important",
                  height: "38px",
                }),
                input: (baseStyles) => ({
                  ...baseStyles,
                  padding: "0px !important",
                  margin: "0px !important",
                  // lineHeight: "1.2 !important",
                  overflow: "visible !important",
                  minHeight: "30px !important",
                  // height: "37px",
                }),
                dropdownIndicator: (baseStyles) => ({
                  ...baseStyles,
                  padding: "0px !important",
                }),
                option: (baseStyles) => ({
                  ...baseStyles,
                  paddingTop: "4px !important",
                  paddingBottom: "4px !important",
                }),
              }}
              classNamePrefix="react-select"
              tabSelectsValue
            />
          </div>
          <div className="mb-3">
            <label htmlFor="access_code" className="form-label">
              Access Code <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="access_code"
              autoComplete="one-time-code"
              maxLength={4}
              name="access_code"
              style={{ height: "37px" }}
              onKeyDown={inputNumber}
              value={validationInputs.access_code}
              onChange={handleValidationInputChange}
            />
          </div>
        </div>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="rounded-2"
            onClick={() => {
              setShowValidationModal(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleValidate}
            className="rounded-2"
            disabled={validateLoader}
          >
            {validateLoader && (
              <span className="spinner-border spinner-border-sm me-2"></span>
            )}
            Validate
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showItemModal}
        onHide={handleItemModalClose}
        keyboard={false}
        backdrop="static"
      >
        <ItemViews id={selectedItemId} hide={handleItemModalClose} />
      </Modal>
    </>
  );
}

export default SaleEdit;
